function getValueFromPath(obj, path) {
    // 숫자인 경우 바로 obj[path]를 반환
    if (!isNaN(path)) {
        return obj[path];
    }

    return path.split('.').reduce((acc, part) => {
        if (part.includes('[')) {
            let [key, index] = part.split(/[\[\]]/).filter(Boolean);
            return index ? acc[key][parseInt(index, 10)] : acc[key];
        }
        return acc[part];
    }, obj);
}

export default getValueFromPath;
